import { Parcel, Item, Address, ShipmentType } from '../../types/common';
import Currency from '../../utils/currency';

export const MAIN_CATEGORY_ENVELOPE = '119';
const CATEGORY_ENVELOPE = '120';
export const MAIN_CATEGORY_OTHERS = '129';
const CATEGORY_OTHERS = '130';

const joinStreet = (street: string) => street.replace(/\n/g, '');

const category = {
  [ShipmentType.DOCUMENT]: { mainCategory: MAIN_CATEGORY_ENVELOPE, category: CATEGORY_ENVELOPE },
  [ShipmentType.PARCEL]: { mainCategory: MAIN_CATEGORY_OTHERS, category: CATEGORY_OTHERS },
};

export const convertParcelsToBoxes = (parcels: Parcel[]) =>
  parcels.map(({ length, width, height, weight }) => ({
    length,
    width,
    height,
    weight,
    quantity: 1,
  }));

export const convertItems = (type: ShipmentType, items: Item[]) =>
  items.map(({ description, value, qty, remarks, countryOfManufacture }) => {
    return {
      ...category[type],
      description,
      remarks: remarks?.trim() !== '' ? remarks : null,
      currency: value.currency,
      value: Currency.parse(value),
      quantity: qty,
      countryOfManufacture: countryOfManufacture,
    };
  });

export const convertAddress = (
  { name, phone, dialCode, street, city, state, postalCode, type, companyName }: Address,
  country: string,
  halId?: string,
) => ({
  area: country === 'HK' ? city : '',
  city: country !== 'HK' ? city : '',
  company: '',
  country: halId ? 'US' : country,
  name,
  phone: phone.toString(),
  phoneCc: dialCode.toString(),
  region: '',
  state: state || '',
  street1: street ? joinStreet(street) : companyName,
  street2: '',
  street3: '',
  type,
  unit: '',
  zip: postalCode || '',
  metadata: {
    halId: halId || '',
  },
});
